import { render, staticRenderFns } from "./msgInfo.vue?vue&type=template&id=61f42568&scoped=true&"
import script from "./msgInfo.vue?vue&type=script&lang=js&"
export * from "./msgInfo.vue?vue&type=script&lang=js&"
import style0 from "./msgInfo.vue?vue&type=style&index=0&id=61f42568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f42568",
  null
  
)

export default component.exports